import React from 'react';
import { SkText } from '../../components/SkeletonLoader/SkeletonLoader';
import styles from '../clients/ClientesPageSkeleton.module.css';

const COL_WIDTHS = [90, 80, 240, 80, 110, 100];

const TableRowSk: React.FC = () => (
  <div className={styles.row}>
    {COL_WIDTHS.map((w, i) => (
      <SkText key={i} width={w} height={13} style={{ flexShrink: 0 }} />
    ))}
  </div>
);

const ComplaintsPageSkeleton: React.FC = () => (
  <div className={styles.skeletonWrapper}>
    <div className={styles.tableCard}>
      {/* 8 rows */}
      {Array.from({ length: 8 }).map((_, i) => <TableRowSk key={i} />)}
    </div>
  </div>
);

export default ComplaintsPageSkeleton;
